var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('page-header'),_c('div',{attrs:{"id":"content"}},[_c('transition',{attrs:{"name":"slide-fade"}},[_c('router-view')],1),_c('page-footer'),_c('to-top')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }